import React, { useState } from "react";
import { FileUpload } from "primereact/fileupload";
import { TabView, TabPanel } from "primereact/tabview";
import { InputText } from "primereact/inputtext";
import { Button } from "primereact/button";
export default function AddVideoStep(props: any) {
  const [activeIndex, setActiveIndex] = useState(0);

  const getEmbedUrl = (url: string) => {
    if (!url) return "";

    const ytMatch = url.match(/(?:youtube\.com\/watch\?v=|youtu\.be\/)([^&]+)/);
    if (ytMatch) return `https://www.youtube.com/embed/${ytMatch[1]}`;

    const vimeoMatch = url.match(/vimeo\.com\/(\d+)/);
    if (vimeoMatch) return `https://player.vimeo.com/video/${vimeoMatch[1]}`;

    // Invalid or unsupported URL
    return "";
  };
  const embedUrl = getEmbedUrl(props.videoUrl);

  const onVideoChange = (e: any) => {
    props.onVideoUrlChange(e.target.value);
  };
  return (
    <div className="card border-0">
      <div className=" border-bottom pb-3 px-4 pt-4">
        <h6 className="mb-1">Add Video</h6>
        <p className="text-muted mb-0 text-12">Add personalized video explanation</p>
      </div>

      <div className="card-body pt-4 px-4">
        <div className=" qp-setting-tab">
          <label htmlFor="file-upload" className="form-label fw-medium text-14">
            Add a Video to Your Proposal
          </label>
          <p className="text-muted small">Personalize your proposal with a video explanation to make it more engaging for your client.</p>

          <TabView activeIndex={activeIndex} onTabChange={(e) => setActiveIndex(e.index)} className="">
            <TabPanel
              header={
                <span>
                  <i className="fa fa-play-circle me-2" />
                  Embed
                </span>
              }
            >
              <div className="card p-4">
                <label htmlFor="video-url" className="form-label fw-medium mb-2">
                  Video URL
                </label>
                <div className="d-flex gap-2">
                  <InputText
                    id="video-url"
                    className="flex-fill"
                    value={props.videoUrl}
                    // onChange={(e) => setVideoUrl(e.target.value)}
                    onChange={onVideoChange}
                    placeholder="https://www.youtube.com/watch?v=..."
                  />
                </div>
                <small className="text-muted mt-2 d-block">YouTube, Vimeo, or other video hosting services</small>
                {embedUrl && (
                  <div className=" mt-2">
                    <div className="">
                      <iframe
                        src={embedUrl}
                        title="YouTube video player"
                        allow="accelerometer; autoplay; clipboard-write; encrypted-media; gyroscope; picture-in-picture"
                        allowFullScreen
                        style={{ height: "400px", width: "100%" }}
                      ></iframe>
                    </div>
                  </div>
                )}
              </div>
            </TabPanel>
            <TabPanel
              header={
                <span>
                  <i className="fa fa-upload me-2" />
                  Upload
                </span>
              }
            >
              <div className="rounded-3 p-4 text-center ">
                {/* <i className="fa fa-upload text-secondary" style={{ fontSize: "2rem" }}></i>
                <p className="text-muted small mt-2 mb-1">Drag and drop your video here</p>
                <p className="text-muted small">(MP4, MOV or WebM (max 100MB))</p>

                <FileUpload
                  id="file-upload"
                  name="policyDeclaration"
                  customUpload
                  mode="basic"
                  chooseLabel="Choose Video"
                  className="mt-3"
                  accept=".mp4,.mov,.webm,"
                  maxFileSize={10000000}
                /> */}
                <h4>Coming Soon</h4>
              </div>{" "}
            </TabPanel>
            <TabPanel
              header={
                <span>
                  <i className="fa fa-magic me-2" />
                  AI Generate
                </span>
              }
            >
              <div className="rounded-3 p-4 text-center ">
                <h4>Coming Soon</h4>
              </div>{" "}
            </TabPanel>
          </TabView>
        </div>
      </div>
    </div>
  );
}
